import React, { useState } from "react";
import PropTypes from "prop-types";

import globalStyles from "globalStyles";
import { K_MOBILE_SIZE } from "constants.js";
import useWindowSize from "hooks/useWindowSize";

const Button = (props) => {
  const { lineColor, fillColor, text, onClick, style } = props;
  const { width } = useWindowSize();

  const styles = {
    ...pcStyles,
    ...(width < K_MOBILE_SIZE ? mobileStyles : {}),
  };

  const [isHovered, setIsHovered] = useState(false);

  const colorStyle = {
    buttonColor: {
      border: "1px solid",
      backgroundColor: fillColor,
      borderColor: lineColor,
    },
    textColor: {
      color: lineColor,
    },
    underlineColor: {
      backgroundColor: lineColor,
    },
  };

  const underlineWidthStyle = {
    width: isHovered ? "95%" : "0%",
  };

  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ ...styles.button, ...colorStyle.buttonColor, ...style }}
    >
      <span style={{ ...styles.text, ...colorStyle.textColor }}>{text}</span>
      <div
        style={{
          ...styles.underline,
          ...colorStyle.underlineColor,
          ...underlineWidthStyle,
        }}
      />
    </button>
  );
};

const pcStyles = {
  button: {
    paddingLeft: "2.25rem",
    paddingRight: "2.25rem",
    paddingTop: "1rem",
    paddingBottom: "0.75rem",
    textAlign: "center",
    width: "12rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  text: {
    ...globalStyles.spaced,
    fontSize: "1rem",
  },
  underline: {
    height: "0.1rem",
    transition: "0.5s",
  },
};

const mobileStyles = {
  button: {
    paddingLeft: "1.25rem",
    paddingRight: "1.25rem",
    paddingTop: "1rem",
    paddingBottom: "0.75rem",
    textAlign: "center",
    width: "8.5rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  text: {
    ...globalStyles.spaced,
    fontSize: "0.75rem",
  },
};

Button.propTypes = {
  lineColor: PropTypes.string.isRequired,
  fillColor: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.shape().isRequired,
};

export default Button;
